module.exports = __webpack_public_path__ + "static/media/HURDCO_logo.b675f827.png";